exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".delPay[data-v-5f0f3ab2] {\n  font-size: 0.8rem;\n}\n", ""]);
